// es西班牙
export default {
    "CustomSelect": {
        "请选择": "Selecc.",
    },
    "TopNav": {
        "创作者": "Creador",
        "游客": "Visitante",
        "请登录后体验完整功能": "Inicia sesión para func. completa",
        "登录": "Ingresar",
        "免费试用": "Prueba gratis",
        "退出登录": "Cerrar sesión",
        "个人中心": "Mi cuenta",
        "我的视频": "Mis videos",
        "额度管理": "Gest. créditos",
        "首页": "Inicio",
        "AI创作": "Crear IA",
        "多参考": "Multirref.",
        "文本视频": "Texto a video",
        "图片视频": "Imagen a video",
        "文生图": "Texto a img.",
        "图生图": "Img. a img.",
        "会员中心": "Membresía",
        "概览": "Resumen",
        "我的创作": "Mis creac.",
        "账单管理": "Gest. facturas",
        "生成任务": "Tareas gen.",
        "价格": "Precios",
        "新闻资讯": "Noticias",
        "确定要退出登录吗？": "¿Cerrar sesión?",
        "提示": "Aviso: más detalles = mejor resultado",
        "确定": "Aceptar",
        "取消": "Cancelar",
        "退出成功": "Sesión cerrada",
        '视频展示': 'exhibición de video'
    },
    "AiLayout": {
        "AI创作中心": "Centro IA",
        "视频生成": "Video",
        "图片生成": "Gen. imagen",
        "我的作品": "Mis obras",
        "我的创作": "Mis creac.",
        "今日剩余额度": "Créditos hoy",
        "多参考": "Multirref.",
        "文本视频": "Texto a video",
        "图片视频": "Imagen a video",
        "文生图": "Texto a img.",
        "图生图": "Img. a img.",
    },
    "HomeLayout": {
        "下一代AI视频生成平台": "La próxima gen. IA de video",
        "产品": "Productos",
        "AI视频": "Video IA",
        "价格方案": "Planes",
        "新闻资讯": "Noticias",
        "支持": "Soporte",
        "帮助中心": "Centro ayuda",
        "API文档": "Doc. API",
        "常见问题": "Preg. frecu.",
        "法律": "Legal",
        "服务条款": "Términos",
        "隐私政策": "Privacidad",
        "使用协议": "Acuerdo uso",
        "版权所有": "Derechos reserv.",
        "客服邮箱": "Email soporte",
        "复制邮箱": "Copiar email",
        "开发中": "En desarrollo",
        "链接已复制到剪贴板": "Enlace copiado",
    },
    "MyLayout": {
        "创作者": "Creador",
        "退出登录": "Cerrar sesión",
        "概览": "Resumen",
        "我的创作": "Mis creac.",
        "会员中心": "Membresía",
        "额度管理": "Gest. créditos",
        "账单管理": "Gest. facturas",
        "生成任务": "Tareas gen.",
        "确定要退出登录吗？": "¿Cerrar sesión?",
        "提示": "Aviso: más detalles = mejor resultado",
        "确定": "Aceptar",
        "取消": "Cancelar",
        "退出成功": "Sesión cerrada",
    },
    "Image": {
        "文本生成图片": "Texto a img.",
        "图片生成图片": "Imagen a imagen",
        "用文字描述": "Describe con texto",
        "上传图片素材": "Subir material de imagen, compatible con generación de múltiples imágenes",
        "图片描述": "Descripción",
        "描述您想要的图片": "Describe la imagen deseada",
        "提示描述越详细效果越好": "Consejo: Cuanto más detallada sea la descripción, mejor será el resultado de generación",
        "图片素材": "Material img. (máx. 9)",
        "预览图片": "Vista prev.",
        "上传图片": "Subir img.",
        "支持格式JPGPNG": "Compatible con formatos JPG y PNG",
        "最多": "Máx.",
        "张图片": "imagen(es)",
        "超过大小限制": "Supera el límite de 10 MB",
        "不是图片文件": "No es un archivo de imagen",
        "最多上传": "Máx.",
        "请先上传图片": "Sube una imagen primero",
        "请选择要生成的图片": "Selecciona la imagen a generar",
        "生成结果": "Resultado",
        "重新生成成功": "Regeneración exitosa",
        "模型": "Modelo",
        "请选择模型": "Selecc. modelo",
        "分辨率": "Resolución",
        "请选择分辨率": "Selecc. res.",
        "图片比例": "Relación",
        "补充描述": "Descripción (opc.)",
        "补充描述提示": "Opcional: describe cualquier efecto o estilo adicional que quieras que tenga la imagen",
        "开始绘制": "Generar",
        "开始生成": "Generar",
        "生成中": "Generando",
        "生成成功": "Éxito",
        "图片生成成功": "¡Imagen creada!",
        "作品已保存到我的作品": "La obra se ha guardado en 'Mis obras'",
        "继续创作": "Seguir",
        "查看作品": "Ver obra",
        "请输入图片描述": "Describe la imagen",
    },
    "MyCreation": {
        "我的创作": "Mis creac.",
        "查看和管理您的所有作品": "Gestiona tus obras",
        "预览": "Vista prev.",
        "下载": "Descargar",
        "编辑": "Editar",
        "分享": "Compartir",
        "删除": "Eliminar",
        "暂无作品": "Sin obras",
        "去创作": "Crear",
        "确定删除": "¿Eliminar?",
        "确定要删除作品": "¿Eliminar obra",
        "吗？": "?",
        "此操作不可恢复": "Acción irreversible",
        "取消": "Cancelar",
        "分享作品": "Compartir",
        "复制链接": "Copiar enlace",
        "全部": "Todo",
        "视频": "Video",
        "图片": "Imagen",
        "正在下载:": "Descargando:",
        "链接已复制到剪贴板": "Enlace copiado",
        "删除成功": "Eliminado",
    },
    "Video": {
        "文本生成视频": "Texto a video",
        "图片生成视频": "Img. a video",
        "智能视频生成": "Generación inteligente de video",
        "输入文字描述": "Describe con texto",
        "上传1-9张图片": "Sube de 1 a 9 imágenes",
        "上传图片视频音频": "Subir img/video/audio",
        "视频描述": "Descripción",
        "描述您想要的视频场景": "Describe la escena",
        "提示": "Aviso: más detalles = mejor resultado",
        "图片素材": "Material img. (máx. 9)",
        "最多上传": "Subir hasta",
        "张": "imágenes",
        "预览": "Vista prev.",
        "上传图片": "Subir img.",
        "支持格式": "Formatos JPG, PNG, WebP, máx. 10 MB, máx.",
        "AI": "IA genera transición",
        "动态描述": "Descripción de movimiento (opc.)",
        "描述您希望图片如何动起来": "Describe cómo quieres que se mueva la imagen",
        "个": "elementos",
        "上传视频": "Subir video",
        "上传音频": "Subir audio",
        "描述您希望视频呈现的效果": "Describe el efecto deseado",
        "模型": "Modelo",
        "请选择模型": "Selecc. modelo",
        "分辨率": "Resolución",
        "请选择分辨率": "Selecc. res.",
        "宽高比": "Relación",
        "视频时长": "Duración",
        "生成音频": "Generar audio",
        "开启音效": "Activar efectos de sonido",
        "静音模式": "Modo silencio",
        "音频提示": "Consejo: El audio subido se usará como música de fondo. Si no se sube audio, la IA generará música automáticamente",
        "开始生成": "Generar",
        "积分": "Créditos",
        "生成中": "Generando",
        "生成成功": "Éxito",
        "视频生成成功！": "¡Video creado!",
        "作品已保存到": "Guardado en",
        "继续创作": "Seguir",
        "查看作品": "Ver obra",
        "视频预览": "Vista prev.",
        "关闭": "Cerrar",
        "下载视频": "Descargar video",
        "您的浏览器不支持视频播放": "Tu navegador no soporta reproducción de video",
        "生成进度": "Progreso de generación",
        "描述": "Descripción",
        "时长": "Duración",
        "秒": "segundos",
        "视频素材": "Material video (máx. 3, 15s)",
        "音频素材": "Material audio (máx. 3, 15s)",
        "双图融合模式": "Modo de fusión de dos imágenes",
        "开始下载视频": "Descargando video...",
        "请输入视频描述": "Describe el video",
        "请至少上传一张图片": "Sube al menos una imagen",
        "请至少上传一张图片或一个视频": "Sube al menos una imagen o un video",
        "最多只能上传": "Máx. permitido",
        "超过": "Supera",
        "限制": "límite",
        "不是图片文件": "No es un archivo de imagen",
        "不是视频文件": "No es un archivo de video",
        "不是音频文件": "No es un archivo de audio",
    },
    "Forgot": {
        "找回密码": "Recuperar contraseña",
        "请输入您的邮箱，我们将发送验证码": "Ingresa tu correo, te enviaremos un código de verificación",
        "密码重置成功，请使用新密码登录": "Contraseña restablecida, inicia sesión con tu nueva contraseña",
        "密码重置成功": "Contraseña restablecida",
        "您的密码已成功重置，请使用新密码登录": "Tu contraseña se ha restablecido correctamente, inicia sesión con tu nueva contraseña",
        "立即登录": "Iniciar sesión",
        "邮箱": "Correo",
        "请输入注册邮箱": "Ingresa el correo registrado",
        "发送验证码": "Enviar código",
        "请输入验证码": "Ingresa el código de verificación",
        "验证码": "Código de verificación",
        "新密码": "Nueva contraseña",
        "设置新密码": "Establecer nueva contraseña",
        "确认新密码": "Confirmar nueva contraseña",
        "再次输入新密码": "Ingresa la nueva contraseña nuevamente",
        "重置密码": "Restablecer contraseña",
        "返回登录": "Volver a inicio de sesión",
        "验证中": "Verificando",
        "重置中": "Restableciendo",
        "弱": "Débil",
        "中": "Medio",
        "强": "Fuerte",
        "请输入邮箱地址": "Ingresa el correo",
        "请输入正确的邮箱格式": "Formato de correo inválido",
        "验证码应为6位数字": "El código de verificación debe tener 6 dígitos",
        "请输入新密码": "Ingresa una nueva contraseña",
        "密码至少需要6位": "Mín. 6 caracteres",
        "请再次输入新密码": "Ingresa la nueva contraseña nuevamente",
        "两次输入的密码不一致": "Las contraseñas no coinciden",
        "验证码已发送": "Código de verificación enviado",
    },
    "Login": {
        "下一代AI视频生成平台": "La próxima gen. IA de video",
        "一键生成": "Gen. 1 clic",
        "支持4K超高清输出": "Salida 4K",
        "多种风格模板任选": "Múltiples estilos",
        "商用授权无忧使用": "Uso comercial",
        "欢迎回来": "Bienvenido, Creador",
        "登录您的账号继续创作": "Inicia sesión para continuar creando",
        "邮箱": "Correo",
        "请输入邮箱地址": "Ingresa el correo",
        "密码": "Contraseña",
        "请输入您的密码": "Ingresa tu contraseña",
        "记住我": "Recordar",
        "忘记密码？": "¿Olvidaste tu contraseña?",
        "登录": "Iniciar sesión",
        "登录中": "Iniciando sesión...",
        "还没有账号？": "¿No tienes cuenta?",
        "立即注册": "Regístrate",
        "请输入正确的邮箱格式": "Formato de correo inválido",
        "请输入密码": "Ingresa la contraseña",
        "密码至少需要6位": "Mín. 6 caracteres",
        "密码不能超过20位": "La contraseña no puede exceder los 20 caracteres",
        "登录成功": "Sesión iniciada correctamente",
    },
    "Register": {
        "创建账号": "Crear cuenta",
        "开始您的AI视频创作之旅": "Comienza tu viaje de creación con IA",
        "姓名": "Nombre",
        "请输入您的姓名": "Ingresa tu nombre",
        "邮箱": "Correo",
        "请输入邮箱地址": "Ingresa el correo",
        "获取验证码": "Obtener código de verificación",
        "验证码": "Código de verificación",
        "请输入验证码": "Ingresa el código de verificación",
        "密码": "Contraseña",
        "设置密码": "Establecer contraseña (mín. 6 caracteres)",
        "确认密码": "Confirmar contraseña",
        "再次输入密码": "Repite la contraseña",
        "我已阅读并同意": "Acepto los",
        "服务条款": "Términos de servicio",
        "和": "y",
        "隐私政策": "Política de privacidad",
        "注册中": "Registrando...",
        "已有账号？": "¿Ya tienes cuenta?",
        "立即登录": "Iniciar sesión",
        "弱": "Débil",
        "中": "Medio",
        "强": "Fuerte",
        "请输入姓名": "Ingresa el nombre",
        "姓名至少需要2个字符": "El nombre debe tener al menos 2 caracteres",
        "姓名不能超过20个字符": "El nombre no puede exceder los 20 caracteres",
        "请输入正确的邮箱格式": "Formato de correo inválido",
        "验证码应为6位数字": "El código de verificación debe tener 6 dígitos",
        "请输入密码": "Ingresa la contraseña",
        "密码至少需要6位": "Mín. 6 caracteres",
        "密码不能超过20位": "La contraseña no puede exceder los 20 caracteres",
        "请再次输入密码": "Confirma la contraseña",
        "两次输入的密码不一致": "Las contraseñas no coinciden",
        "验证码已发送": "Código de verificación enviado",
        "注册成功": "Registrado correctamente",
    },
    "Faq": {
        "常见问题": "Preguntas frecuentes",
        "您在使用过程中遇到的问题": "Soluciones a tus dudas",
        "搜索您的问题": "Buscar...",
        "没有找到相关的问题": "No se encontraron resultados",
        "查看全部问题": "Ver todas",
        "没有找到您想要的答案？": "¿No encontraste la respuesta que buscabas?",
        "我们的客服团队随时为您提供帮助": "Nuestro equipo de soporte está disponible para ayudarte",
        "复制客服邮箱": "Copiar correo de soporte",
        "链接已复制到剪贴板": "Enlace copiado",
    },
    "Home": {
        '立即订阅': 'Suscríbete ahora',
        "AI视频生成新时代": "Nueva era de generación de video con IA",
        "用文字创造": "Crea con texto",
        "无限视频": "Videos ilimitados",
        "让每个人都能成为视频创作者": "Cualquiera puede crear videos",
        "免费开始": "Empieza gratis",
        "观看演示": "Ver demostración",
        "AI生成": "Generar con IA",
        "AI视频": "Video con IA",
        "三步轻松生成专业视频": "3 pasos para crear videos profesionales",
        "输入提示词": "Escribe un prompt",
        "用文字描述您想要的视频内容": "Describe el video que deseas",
        "智能生成": "Generación inteligente",
        "AI模型自动理解并创作": "La IA entiende y crea automáticamente",
        "下载作品": "Descargar obra",
        "高清视频生成完成": "Video en HD listo",
        "AI视频生成": "Generación de video con IA",
        "精彩视频": "Texto a video",
        "描述您想要的视频场景": "Describe la escena del video",
        "生成中": "Generando",
        "生成视频": "Generar video",
        "AI图片": "Imagen con IA",
        "精美图片": "Texto a imagen",
        "描述您想要的图片场景": "Describe la imagen que deseas",
        "生成图片": "Generar imagen",
        "强大功能": "Funciones potentes",
        "让视频创作变得简单有趣": "Creación de videos simple y divertida",
        "案例展示": "Ejemplos",
        "来看看用户使用": "Ver obras creadas por",
        "创作的精彩作品": "usuarios",
        "新闻资讯": "Noticias",
        "了解": "Descubre las",
        "的最新动态和产品更新": "novedades y actualizaciones",
        "查看更多": "Ver más",
        "热门": "Popular",
        "最新": "Reciente",
        "阅读更多": "Leer más",
        "选择适合您的方案": "Elige el plan que más te convenga",
        "灵活的定价": "Precios flexibles",
        "视频预览": "Vista previa",
        "生成成功": "Éxito",
        "作品已保存到": "Guardado en",
        "继续创作": "Seguir creando",
        "查看作品": "Ver obra",
        "请输入视频描述": "Describe el video",
        "视频生成成功！": "¡Video generado con éxito!",
        "请输入图片描述": "Describe la imagen",
        "图片生成成功！": "¡Imagen generada con éxito!",
    },
    "News": {
        "新闻资讯": "Noticias",
        "了解": "Descubre las",
        "的最新动态和产品更新": "novedades y actualizaciones",
        "精选": "Destacadas",
        "阅读": "Leer",
        "点赞": "Me gusta",
        "热门": "Popular",
        "最新": "Reciente",
        "阅读更多": "Leer más",
        "加载中": "Cargando...",
        "暂无新闻": "No hay noticias",
        "清除筛选": "Limpiar filtro",
        "加载新闻失败": "Error al cargar noticias",
    },
    "Price": {
        "选择适合您的方案": "Elige el plan que más te convenga",
        "灵活的定价": "Precios flexibles",
        "包月": "Mensual",
        "包年": "Anual",
        "购买积分": "Comprar créditos",
        "只需要几个视频": "¿Solo necesitas unos pocos videos? Compra créditos",
        "产品大全": "Catálogo de productos",
        "了解": "Descubre la",
        "全系列产品的详细信息和支付方式": "información detallada y métodos de pago de toda la gama de productos",
    },
    "Billing": {
        "账单管理": "Gestión de facturas",
        "账户余额": "Saldo de la cuenta",
        "本月支出": "Gastos del mes",
        "订单数量": "Número de pedidos",
        "账单列表": "Lista de facturas",
        "请选择类型": "Selecciona el tipo",
        "请选择时间范围": "Selecciona el rango de fechas",
        "订单号": "N° de pedido",
        "类型": "Tipo",
        "金额": "Monto: ",
        "状态": "Estado",
        "时间": "Fecha",
        "操作": "Acción",
        "查看详情": "Ver detalles",
        "下载发票": "Descargar factura",
        "暂无作品": "Sin obras",
        "去创作": "Crear",
        "支付方式": "Método de pago",
        "添加支付方式": "Agregar",
        "默认": "Predeterminado",
        "设为默认": "Establecer como predet.",
        "编辑": "Editar",
        "删除": "Eliminar",
        "账单详情": "Detalles de la factura",
        "交易流水号": "N° de transacción",
        "关闭": "Cerrar",
        "账号": "Cuenta/n° de tarjeta",
        "请输入账号或卡号": "Ingresa el n° de cuenta o tarjeta",
        "姓名": "Nombre",
        "请输入持卡人姓名": "Ingresa el nombre del titular",
        "有效期": "Fecha de vencimiento",
        "请输入CVV码": "Ingresa el código CVV",
        "取消": "Cancelar",
        "确认添加": "Agregar",
        "确认修改": "Modificar",
        "确认删除": "Eliminar",
        "编辑支付方式": "Editar método de pago",
        "确定要删除支付方式": "¿Eliminar este método de pago?",
        "删除后不可恢复": "Esta acción no se puede deshacer",
        "请输入账号": "Ingresa el n° de cuenta",
        "添加成功": "Agregado correctamente",
        "修改成功": "Modificado correctamente",
        "已设为默认支付方式": "Establecido como método de pago predeterminado",
        "删除成功": "Eliminado correctamente",
    },
    "Credit": {
        "额度管理": "Gestión de créditos",
        "当前可用额度": "Créditos disponibles",
        "升级会员": "Mejorar membresía",
        "本月已用": "Usado este mes",
        "视频生成": "Video",
        "AI图片": "Imagen IA",
        "其他": "Otros",
        "购买额度包": "Comprar paquete de créditos",
        "最受欢迎": "Más popular",
        "额度": "Créditos",
        "立即购买": "Comprar ahora",
        "使用记录": "Historial de uso",
        "操作": "Acción",
        "类型": "Tipo",
        "额度变动": "Cambio de créditos",
        "时间": "Fecha",
        "购买": "Comprar",
        "确认购买": "Confirmar compra",
        "金额": "Monto: ",
        "获得": "Obtienes",
        "取消": "Cancelar",
        "今天": "Hoy",
        "昨天": "Ayer",
    },
    "Dashboard": {
        "欢迎回来": "Bienvenido de vuelta, Creador",
        "创建新视频": "Crear nuevo video",
        "本月生成次数": "Generaciones este mes",
        "剩余额度": "Créditos restantes",
        "总视频数": "Total de videos",
        "会员状态": "Estado de membresía",
        "最近生成": "Generaciones recientes",
        "查看全部": "Ver todo",
        "视频预览": "Vista previa del video",
        "视频生成中": "Generando video...",
    },
    "Membership": {
        "会员中心": "Centro de membresía",
        "当前方案": "Plan actual",
        "Pro 会员": "Pro",
        "专业创作者首选": "Ideal para creadores profesionales",
        "月": "mes",
        "会员有效期": "Vigencia de la membresía",
        "剩余天数": "Días restantes",
        "续费会员": "Renovar membresía",
        "取消订阅": "Cancelar suscripción",
        "本月使用情况": "Uso de este mes",
        "视频生成": "Video",
        "次": "veces",
        "额度使用": "Uso de créditos",
        "快速生成": "Generación rápida",
        "升级方案": "Mejorar de plan",
        "联系销售": "Contactar a ventas",
        "会员权益": "Beneficios de membresía",
        "续费后将延长会员有效期30天": "Renovar extiende la membresía por 30 días",
        "取消": "Cancelar",
        "确认续费": "Confirmar renovación",
        "取消后您将失去所有会员权益": "Al cancelar perderás todos los beneficios, los créditos restantes se conservan",
        "再想想": "Reconsiderar",
        "确认取消": "Confirmar cancelación",
        "姓名": "Nombre",
        "请输入您的姓名": "Ingresa tu nombre",
        "请输入姓名": "Ingresa el nombre",
        "公司": "Empresa",
        "请输入公司名称": "Ingresa el nombre de la empresa",
        "邮箱": "Correo",
        "请输入邮箱地址": "Ingresa el correo",
        "请输入邮箱": "Ingresa el correo",
        "请输入正确的邮箱格式": "Formato de correo inválido",
        "需求": "Requisito",
        "请描述您的需求": "Describe tu necesidad",
        "提交": "Enviar",
        "请填写需求": "Por favor describe tu necesidad",
        "续费成功": "Renovación exitosa",
        "已取消订阅": "Suscripción cancelada",
        "提交成功": "Enviado correctamente, nos pondremos en contacto contigo",
    },
    "Task": {
        "生成任务": "Tareas de generación",
        "新建任务": "Nueva tarea",
        "进行中": "En curso",
        "已完成": "Completada",
        "失败": "Fallida",
        "队列中": "En cola",
        "活跃任务": "Tareas activas",
        "刷新": "Actualizar",
        "暂无活跃任务": "No hay tareas activas",
        "预计剩余": "Tiempo restante estimado",
        "暂停": "Pausar",
        "继续": "Continuar",
        "取消": "Cancelar",
        "最近完成": "Completadas recientemente",
        "查看全部": "Ver todo",
        "暂无完成的任务": "No hay tareas completadas",
        "播放": "Reproducir",
        "下载": "Descargar",
        "分享": "Compartir",
        "确认取消": "Confirmar cancelación",
        "确定要取消任务吗": "¿Estás seguro de que quieres cancelar la tarea?",
        "已消耗的额度将无法退还": "Los créditos consumidos no serán reembolsables",
        "返回": "Volver",
        "分享作品": "Compartir obra",
        "复制链接": "Copiar enlace",
        "任务列表已刷新": "Lista de tareas actualizada",
        "已暂停": "Pausada",
        "生成中": "Generando",
        "已恢复": "Reanudada",
        "任务已取消": "Tarea cancelada",
        "链接已复制到剪贴板": "Enlace copiado",
    },
    "VideoShow": {
        '示例': 'Ejemplos',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Una selección cuidadosamente elegida de clips de nuestra biblioteca de demostración. Haz clic en cualquier tarjeta para empezar a generar contenido con un estilo similar.',
        '全部': 'Todos',
        '电影感': 'Cinematográfico',
        '角色': 'Personajes',
        '产品': 'Productos',
        '自然': 'Naturaleza',
        '趣味': 'Divertido',
        '加载中': 'Cargando',
        '暂无展示': 'No hay demostraciones disponibles',
        '视频预览': 'Vista previa de video',
    },
    Request: {
        '加载中': 'Cargando...',
        '您已退出登录': 'Has cerrado sesión, puedes volver a iniciar sesión',
        '确认退出': 'Confirmar cierre de sesión',
        '重新登录': 'Iniciar sesión nuevamente',
        '错误': 'Error',
        '网络错误': 'Error de red',
        '下载中': 'Descargando...'
    },
    Other: {
        '剩余额度': 'Saldo restante',
        '去登录': 'Iniciar sesión',
        '请登录后查看': 'Por favor, inicia sesión para ver',
        '任务': 'Tarea',
        '可在「生成任务」中查看详情': ', puedes ver los detalles en "Tareas de generación"',
        '查看详情': 'Ver detalles',
        '排队中': 'En cola',
        '运行中': 'En ejecución',
        '取消': 'Cancelar',
        '成功': 'Éxito',
        '失败': 'Fallido',
        '超时': 'Tiempo agotado',
        '最后更新': 'Última actualización:',
        '视频生成': 'Generación de video',
        '活跃用户': 'Usuarios activos',
        '用户评分': 'Calificación de usuarios',
        '万': 'mil',
        '快速生成': 'Generación rápida',
        '先进的AI模型': 'Modelos de IA avanzados que generan videos de alta calidad en minutos',
        '多种风格': 'Múltiples estilos',
        '多种风格任您选择': 'Realista, anime, artístico y más, elige el que quieras',
        '高清输出': 'Salida de alta definición',
        '支持4K超高清视频输出': 'Soporta salida de video 4K ultra alta definición, con detalles nítidos',
        '商用授权': 'Licencia comercial',
        '生成的视频可用于商业用途': 'Los videos generados se pueden usar para fines comerciales, sin preocupaciones de derechos de autor',
        '原价': 'Precio original',
        '积分价格说明': 'Explicación del precio de los créditos',
        '系列': 'Serie',
        '模型': 'Modelo',
        '分辨率': 'Resolución',
        '积分': 'Créditos',
        '秒': 'segundo',
        '秒示例': 'segundos (ejemplo)',
        '图片模型': 'Modelo de imagen',
        '图片为': 'La imagen es',
        '系列产品': 'Productos de la serie, actualmente compatible con',
        '支持使用任意机型查看完整体验': ', compatible con cualquier dispositivo para una experiencia completa.',
        '计费方式': 'Método de facturación',
        '张': 'imagen(es)',
        '按生成张数计费': 'Facturación por número de imágenes generadas',
        '普通用户': 'Usuario normal',
        '无记录': 'Sin registros',
        '总支出': 'Gasto total',
        '月总使用': 'Uso total mensual',
        '月视频使用': 'Uso de video mensual',
        '月图片使用': 'Uso de imagen mensual',
        '生成成功': 'Generación exitosa',
        '视频总生成': 'Total de videos generados',
        '图片总生成': 'Total de imágenes generadas',
        '生成中': 'Generando, por favor espera de 1 a 3 minutos',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Una colección cuidadosamente seleccionada de clips de nuestra biblioteca de demostración.',
        '最近7天': 'Últimos 7 días',
        '最近30天': 'Últimos 30 días',
        '本月': 'Este mes',
        '上月': 'Mes pasado',
    }
}